import { useEffect, useState } from 'react';
import { useFrame } from "@react-three/fiber";
import { Environment } from '@react-three/drei';
import { Vector3 } from 'three';

// Any negative number so this will happen before frame is rendered
const RENDER_PRIORITY_ENV_ROTATION = -50;

const _CameraFwd = new Vector3();

export const  CustomEnvironment = ({ intensity = 1, blur = 0, x = 0, y = 0, z = 0, file, userEnvironment, lockHdriRotationToCamera }) => {
    const [canRenderEnv, setCanRenderEnv] = useState(!userEnvironment);

    useEffect(() => {
        fetch(file)
            .then((res) => {
                if (res.ok) {
                    setCanRenderEnv(true);
                } else {
                    console.warn(`[Dimensions 3D] - can not fetch HDRI environment file: "${file}". Returned status: ${res.status}. "${res.statusText}"`);
                }
            })
            .catch((e) => console.warn(`[Dimensions 3D] - can not fetch HDRI environment file: "${file}". Returned error: ${e}`))
    }, [file]);

    useFrame( (state) => {
        if (lockHdriRotationToCamera && state.camera) {
            _CameraFwd.set(0,0,1);
            state.camera.localToWorld(_CameraFwd);
            const lookYRotRad = Math.atan2(_CameraFwd.x, _CameraFwd.z);
            state.scene.environmentRotation.set(0, lookYRotRad + y, 0);
        }
      }, RENDER_PRIORITY_ENV_ROTATION);
    
    return (
        canRenderEnv ?
            <Environment
                background={false}
                environmentRotation={[0, y, 0]}
                environmentIntensity={intensity}
                files={file}
                // backgroundBlurriness={blur} // not relevant since we don't use the env as a background
            /> : null
    );
};
